import React, { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { getUserCart, getUserDesires } from "../../actions";
import { generatePublicUrl } from "../../urlConfig";
import PicturesViews from "../../components/Pictures/PicturesViews";
import Loader from "../../components/Loader";
import EmptyMessage from "./EmptyMessage";

const UserProductContainer = ({
    typeModal,
    userId,
    cart,
    desires,
    loading,
    message,
}) => {
    const dispatch = useDispatch();

    useEffect(() => {
        if (typeModal === "cart") dispatch(getUserCart(userId));
        if (typeModal === "desires") dispatch(getUserDesires(userId));
    }, [dispatch, typeModal, userId]);

    const items = useMemo(() => (
        typeModal === "cart" ? cart?.cartItems : desires?.desiresItems
    ), [cart?.cartItems, desires?.desiresItems, typeModal]);

    const safeItems = Array.isArray(items) ? items : [];
    const isCart = typeModal === "cart";

    return (
        <div className="userSection">
            <div className="userSection__head">
                <div>
                    <span>{isCart ? "Корзина" : "Понравившиеся"}</span>
                    <h3>{isCart ? "Товары в корзине" : "Понравившиеся товары"}</h3>
                    <p>Всего позиций: {safeItems.length}.</p>
                </div>
            </div>

            <div className="userProductContainer">
                {loading ? (
                    <Loader />
                ) : !safeItems.length ? (
                    <EmptyMessage message={message || "У пользователя пока нет товаров."} />
                ) : (
                    <div className="userProductContainer__row">
                        <div className="userProductContainer__productBox">
                            {safeItems.map((item) => {
                                const picture = item?.product?.productPictures?.[0]?.img;
                                const name = item?.product?.fullName || "Товар";

                                return (
                                    <div className="userProductContainer__itemProd" key={item._id}>
                                        <div className="userProductContainer__imgBox">
                                            <div className="userProductContainer__imgBox__img">
                                                {picture ? <img src={generatePublicUrl(picture)} alt={name} /> : null}
                                                {item?.product ? (
                                                    <div className="userProductContainer__viewsLength">
                                                        <PicturesViews top="0px" picture={item.product} />
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="userProductContainer__textBox">
                                            <div className="userProductContainer__fullName">{name}</div>
                                            <div className="userProductContainer__createdAt">
                                                {item.createdAt ? `${item.createdAt.slice(0, 10)} ${item.createdAt.slice(11, 19)}` : "—"}
                                            </div>
                                            {isCart ? (
                                                <div className="userProductContainer__quantity">
                                                    <span>Кол-во:</span> {item.quantity || 1}
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default UserProductContainer;
